export default __webpack_public_path__ + "static/media/favicon.a6d34ae9.png";